export class RankersService {
  rankers2023: any[] = [
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Guru.jpeg', name: 'Guru Charan', persentage: 'CAT 99.99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/pixelup+5.jpg', name: 'Manav Jain', persentage: 'CAT 99.99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Prikshit+tomer.jpeg', name: 'Parikshit Tomar', persentage: 'CAT 99.99%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/10/satyajitdas-670faf752a4fb.webp', name: 'Satyajit Das', persentage: 'CAT 99.97%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/swadesh+rath.jpeg', name: 'Swadesh Rath', persentage: 'CAT 99.97%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Aditya+singh.jpeg', name: 'Aditya Singh', persentage: 'CAT 99.95%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/sourabhdeep-66e94dbeba245.webp', name: 'Souradeep Banerjee', persentage: 'CAT 99.95%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Soumbhra+mukher+jee.jpeg', name: 'Soumbhra mukher jee', persentage: 'CAT 99.94%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/rahul+dandwate.jpeg', name: 'Rahul dandwate', persentage: 'CAT 99.92%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Umesh chandra', persentage: 'CAT 99.91%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Dhruv jajoo', persentage: 'CAT 99.91%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/10/nikhildhing-6710a0e4d35fe.webp', name: 'Nikhil dhing', persentage: 'CAT 99.9%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/10/rounaktikmani-670fac2e0af7d.webp', name: 'Rounak Tikmani', persentage: 'CAT 99.9%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubham Garg', persentage: 'CAT 99.9%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/venugoudamargani-66e94d8215ac4.webp', name: 'Venu Goud Amargani', persentage: 'CAT 99.9%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shivam singh', persentage: 'CAT 99.9%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jai Rawal', persentage: 'CAT 99.88%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Archit aggarwal', persentage: 'CAT 99.88%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/diwakar(1).jpeg', name: 'Diwakar singh tanwar', persentage: 'CAT 99.87%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/ritvikmanglik-66e94d800b3f3.webp', name: 'Ritvik Manglik', persentage: 'CAT 99.87%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Mayukh+roy.jpeg', name: 'Mayukh Roy', persentage: 'CAT 99.87%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/nupur+kokate.jpeg', name: 'Nupur Kokate', persentage: 'CAT 99.86%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/10/abhishekmishra-6710a04e0b976.webp', name: 'Abhishek mishra', persentage: 'CAT 99.85%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Rishav+banerjee.jpeg', name: 'RishavBanerjee', persentage: 'CAT 99.83%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pratyush Singh', persentage: 'CAT 99.83%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/bhavya+shah.jpeg', name: 'Bhavya Shah', persentage: 'CAT 99.82%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Mehul+jain.jpg', name: 'Mehul jain', persentage: 'CAT 99.82%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Nayana+nair.jpeg', name: 'Nayana Nair', persentage: 'CAT 99.8%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'AVIK DAS', persentage: 'CAT 99.78%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Kashish', persentage: 'CAT 99.78%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/yash+kabra.jpeg', name: 'Yash kabra', persentage: 'CAT 99.78%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/shrishti+varshney.png', name: 'Shristi Varshney', persentage: 'CAT 99.76%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/vivek+goyal.jpeg', name: 'VIVEK GOYAL', persentage: 'CAT 99.75%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/swapna+neil+paul.jpeg', name: 'Swapna Neil Paul', persentage: 'CAT 99.75%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ashutosh Aggarwal', persentage: 'CAT 99.75%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/krishna.png', name: 'Krishna Jaisansaria', persentage: 'CAT 99.75%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Deepanshu Mittal', persentage: 'CAT 99.74%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'vishesh gupta', persentage: 'CAT 99.74%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Advik Jain', persentage: 'CAT 99.73%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/paluk+shukla.png', name: 'Paluk Shukla', persentage: 'CAT 99.73%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Utkarsh+gupta.jpg', name: 'Utkarsh Gupta', persentage: 'CAT 99.73%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aditya Sehgal', persentage: 'CAT 99.73%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/G+Sreekara+Reddy.jpg', name: 'G Sreekara Reddy', persentage: 'CAT 99.69%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Vidya+datta.jpeg', name: 'Vidya Datta Vivek K', persentage: 'CAT 99.68%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Avinash Herle', persentage: 'CAT 99.66%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Divyanshu Garg', persentage: 'CAT 99.6%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Varsha Rai', persentage: 'CAT 99.6%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Nandha', persentage: 'CAT 99.6%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ishan jalan', persentage: 'CAT 99.6%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Shubham+rastogi.jpeg', name: 'Shubham Rustagi', persentage: 'CAT 99.57%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/mohita.jpg', name: 'Mohita Carmen K', persentage: 'CAT 99.57%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/om+srivastav.jpeg', name: 'OM Srivastav', persentage: 'CAT 99.53%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Shuvam+Debnath.jpeg', name: 'Suvam Debnath', persentage: 'CAT 99.52%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Archisman+gupta.png', name: 'Archisman gupta', persentage: 'CAT 99.51%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Riman+bortharpur.jpg', name: 'Riman Borthakur', persentage: 'CAT 99.45%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Simran+Gupta.jpeg', name: 'Simran Gupta', persentage: 'CAT 99.45%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'yashvir brar', persentage: 'CAT 99.4%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'divyansh', persentage: 'CAT 99.4%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Abhishek deskhmukh', persentage: 'CAT 99.37%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Shreyas+Panda.jpeg', name: 'Shreyas Panda', persentage: 'CAT 99.34%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Nairirti', persentage: 'CAT 99.34%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Naman Sauparia', persentage: 'CAT 99.32%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Shreekeerthana.jpeg', name: 'Shreekeerthana', persentage: 'CAT 99.32%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Tanush+Biju.png', name: 'Tanush Biju', persentage: 'CAT 99.32%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/aravintakshan.png', name: 'Aravintakshan', persentage: 'CAT 99.31%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/tejaswini.png', name: 'Tejaswini', persentage: 'CAT 99.3%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Saumya', persentage: 'CAT 99.3%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Roopal Singh', persentage: 'CAT 99.3%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/sayan.png', name: 'Sayan KumarMaity', persentage: 'CAT 99.29%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ria', persentage: 'CAT 99.28%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Nandini Jain', persentage: 'CAT 99.26%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/suchit+arora.jpg', name: 'Suchit Arora', persentage: 'CAT 99.25%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/mahima+Sharma.png', name: 'Mahima Sharma', persentage: 'CAT 99.25%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Sarvesh Shahshidhar', persentage: 'CAT 99.23%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/sahil+shetty+j.jpg', name: 'Sahil Shetty', persentage: 'CAT 99.21%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/sarthak.png', name: 'Sarthak Sathapathy', persentage: 'CAT 99.21%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Priyan Sood', persentage: 'CAT 99.21%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Tanish.jpg', name: 'Tanish', persentage: 'CAT 99.2%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Sree sarath chandra', persentage: 'CAT 99.2%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/pragdeesh.jpeg', name: 'Pragdeesh', persentage: 'CAT 99.2%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Noel John', persentage: 'CAT 99.2%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/sushant.jpg', name: 'Sushant Elbhor', persentage: 'CAT 99.19%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/aditya+bose.jpg', name: 'Aditya bose', persentage: 'CAT 99.16%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Rahul Palit', persentage: 'CAT 99.16%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/shen+shaji.jpg', name: 'Shen Shaji', persentage: 'CAT 99.16%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Sagnik+Dutta.jpg', name: 'Sagnik Dutta', persentage: 'CAT 99.15%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Divyansh+Sharma.jpg', name: 'Divyansh Sharma', persentage: 'CAT 99.14%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Avyay+Varma.png', name: 'Avyay Varma', persentage: 'CAT 99.13%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jatin Dialani', persentage: 'CAT 99.13%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Rishi+Kant.jpg', name: 'Rishi Kant', persentage: 'CAT 99.12%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Jytri+Veeramachaneni.jpg', name: 'Jytri Veeramachaneni', persentage: 'CAT 99.11%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Tanuk Mittal', persentage: 'CAT 99.11%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Arunva+Chakraborty+.jpg', name: 'Arunva Chakraborty', persentage: 'CAT 99.08%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Ritwik+Jha.jpg', name: 'Ritwik Jha', persentage: 'CAT 99.08%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Gaurav Vicky', persentage: 'CAT 99.06%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ashwin V Venkatesh', persentage: 'CAT 99.03%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shanay Shah', persentage: 'CAT 99.01%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Mohith+Kamatam.jpg', name: 'Mohith kamatam', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Abhishek Mangal', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Krishna Jaisansaria', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Ashrai+Paul.png', name: 'Ashrai paul', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Durga.jpg', name: 'Durga', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'nikunj', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Vidyanshu shekhar', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Manu Aggarwal', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/payal+pradhan.png', name: 'Payal Pradhan', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Esha jain', persentage: 'CAT 99%ile' },

  ]

  rankers2024: any[] = [
    {
        "name": "Shubh Karman Singh",
        "persentage": "CAT 99.98",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kanav",
        "persentage": "CAT 99.98",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mridul Tiwari",
        "persentage": "CAT 99.98",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vedant Chandewar",
        "persentage": "CAT 99.98",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Himanshu Singh Yadav",
        "persentage": "CAT 99.97",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Swaraj Pal",
        "persentage": "CAT 99.95",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Prakhar Mundra",
        "persentage": "CAT 99.95",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Harshul Ranadive",
        "persentage": "CAT 99.95",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aayush",
        "persentage": "CAT 99.93",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aman Ehtesham",
        "persentage": "CAT 99.93",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sanvie Singhal",
        "persentage": "CAT 99.92",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "MANU AGARWAL",
        "persentage": "CAT 99.91",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Manan Maheshwari",
        "persentage": "CAT 99.91",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rohit Mohta",
        "persentage": "CAT 99.9",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shivalik",
        "persentage": "CAT 99.9",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aniruddh",
        "persentage": "CAT 99.89",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Divyansh Agarwal",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "abhinav sudhini",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sanjeev Chitturi",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Manvendra Singh",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Tara G.",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Souhardya Das",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Ram k",
        "persentage": "CAT 99.85",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "MANGALAM SHARMA",
        "persentage": "CAT 99.85",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Nikhilesh Vetcha",
        "persentage": "CAT 99.85",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Apoorv Swami",
        "persentage": "CAT 99.84",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Amritash Bharadwaj",
        "persentage": "CAT 99.84",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Eshaan",
        "persentage": "CAT 99.84",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anamay Ghate",
        "persentage": "CAT 99.84",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anindya Chatterjee",
        "persentage": "CAT 99.8",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shiladitya Bhadra",
        "persentage": "CAT 99.8",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Satwik Acharya",
        "persentage": "CAT 99.79",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Saksham",
        "persentage": "CAT 99.79",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Devbrat",
        "persentage": "CAT 99.78",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aditya Seth",
        "persentage": "CAT 99.76",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vidyanshu Shekhar",
        "persentage": "CAT 99.76",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Atishay Mariya",
        "persentage": "CAT 99.76",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "KANISK",
        "persentage": "CAT 99.75",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Pradeepkumar Puchala",
        "persentage": "CAT 99.75",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rakshith S",
        "persentage": "CAT 99.73",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rishab Verma",
        "persentage": "CAT 99.73",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Krishna",
        "persentage": "CAT 99.72",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Neerav Chilkoti",
        "persentage": "CAT 99.71",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Akshat Gupta",
        "persentage": "CAT 99.71",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kavya Garg",
        "persentage": "CAT 99.71",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kartikey Gupta",
        "persentage": "CAT 99.7",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anuj Anil Kapse",
        "persentage": "CAT 99.7",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Dhruv Mittal",
        "persentage": "CAT 99.69",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rounak tikmani",
        "persentage": "CAT 99.69",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Khushpreet Singh",
        "persentage": "CAT 99.68",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shreetama Sahu",
        "persentage": "CAT 99.68",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anushka",
        "persentage": "CAT 99.68",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "sudarshan duvvuru",
        "persentage": "CAT 99.68",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rajeev N",
        "persentage": "CAT 99.67",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aditya Prasad Sahu",
        "persentage": "CAT 99.66",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Darsh Raju Mehta",
        "persentage": "CAT 99.66",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Raghvendra Pratap Singh",
        "persentage": "CAT 99.65",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Risheek Arora",
        "persentage": "CAT 99.65",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shinjan Patra",
        "persentage": "CAT 99.65",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Varun",
        "persentage": "CAT 99.63",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Dhruv Bhattacharya",
        "persentage": "CAT 99.63",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kirti Pandey",
        "persentage": "CAT 99.63",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhinav jha",
        "persentage": "CAT 99.63",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "George",
        "persentage": "CAT 99.61",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Arjun Gupta",
        "persentage": "CAT 99.61",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Nitika Shroff",
        "persentage": "CAT 99.6",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Muskan Gupta",
        "persentage": "CAT 99.58",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mansi",
        "persentage": "CAT 99.58",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Gaurav Kumar",
        "persentage": "CAT 99.57",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Yashi Agrawal",
        "persentage": "CAT 99.57",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Akshat Gupta - Akshat ka bhai",
        "persentage": "CAT 99.56",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aayush Vats",
        "persentage": "CAT 99.55",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shambo Sinha",
        "persentage": "CAT 99.55",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rinku Aggarwal",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sania",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aditya Saini",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Parth",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aabhas Kumar",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shaivi Goyal",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Bhagavathi Ravikrishnan",
        "persentage": "CAT 99.52",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sagnik Dutta",
        "persentage": "CAT 99.5",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Om Singh",
        "persentage": "CAT 99.49",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sounak Poddar",
        "persentage": "CAT 99.48",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Hriddhima Saha",
        "persentage": "CAT 99.48",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Arushi Khare",
        "persentage": "CAT 99.48",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Dev Dhanani",
        "persentage": "CAT 99.48",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anindya Chatterjee",
        "persentage": "CAT 99.47",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rahul Sinha",
        "persentage": "CAT 99.47",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhyudaya Gupta",
        "persentage": "CAT 99.47",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vaibhav",
        "persentage": "CAT 99.47",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Maurya Pitti",
        "persentage": "CAT 99.44",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shouvik Chatterjee",
        "persentage": "CAT 99.43",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Bhaanu Ashok",
        "persentage": "CAT 99.43",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Siddhant Kumar",
        "persentage": "CAT 99.42",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Yash Jain",
        "persentage": "CAT 99.42",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Ritika Mathur",
        "persentage": "CAT 99.42",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Jagpreet Singh",
        "persentage": "CAT 99.4",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Akshat Toolaj Sinha",
        "persentage": "CAT 99.4",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aditya Goel - Multiple people availale",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Harsh Gajpalla",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhijeet",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kartik Malhotra",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Souradeep Banerjee",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Harsh Deshpande",
        "persentage": "CAT 99.38",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sarthak Garg",
        "persentage": "CAT 99.38",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "rahulrai65",
        "persentage": "CAT 99.37",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Madhav Varshney",
        "persentage": "CAT 99.36",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "osman baig",
        "persentage": "CAT 99.36",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Bhavya Bajaj",
        "persentage": "CAT 99.36",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Akshay Krishnan R",
        "persentage": "CAT 99.35",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shantanu Goyal",
        "persentage": "CAT 99.35",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vaibhav Rajoriya",
        "persentage": "CAT 99.34",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhishek Kumar",
        "persentage": "CAT 99.33",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Amrinderpreet Singh",
        "persentage": "CAT 99.33",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sridama Singh",
        "persentage": "CAT 99.33",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aanant Agarwal",
        "persentage": "CAT 99.31",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Siddhartha Pal",
        "persentage": "CAT 99.31",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shivank Verma",
        "persentage": "CAT 99.31",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Karan Agrawal",
        "persentage": "CAT 99.31",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Manas Naik",
        "persentage": "CAT 99.3",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Karsheet Negi",
        "persentage": "CAT 99.29",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aman Goel",
        "persentage": "CAT 99.28",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mohit Kumar",
        "persentage": "CAT 99.28",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mithu Singh Rawat - Check",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Lakshay Panwar",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Gariman Gupta",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Suvam Debnath",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "ABHAY SINGH - Multiple ID",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Annu Joseph",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Chitwan Manchanda",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Prakhar Pragya",
        "persentage": "CAT 99.24",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kislay Kashyap",
        "persentage": "CAT 99.2",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Varun S. Roshan",
        "persentage": "CAT 99.2",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhishek Jha",
        "persentage": "CAT 99.2",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rohit Lamba",
        "persentage": "CAT 99.2",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kushagra Nath",
        "persentage": "CAT 99.18",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "aabhas kumar",
        "persentage": "CAT 99.18",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "sajja vasavi vasavi",
        "persentage": "CAT 99.18",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aparna Panicker",
        "persentage": "CAT 99.18",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anand Shukla",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Niteesh",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rohit Mehta",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mihir Kumar",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Dipanwita Ch",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhi",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rajat Pattu",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vanshaj Aggarwal",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kshitij Hegde",
        "persentage": "CAT 99.13",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aayush Gandhi",
        "persentage": "CAT 99.12",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Priyanshu S",
        "persentage": "CAT 99.11",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Safi Ur Rahman",
        "persentage": "CAT 99.11",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Jagannadh",
        "persentage": "CAT 99.11",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aaryaman Dadwal",
        "persentage": "CAT 99.1",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kishlay Kinjal",
        "persentage": "CAT 99.1",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vishesh Madaan",
        "persentage": "CAT 99.1",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anurag Kedia",
        "persentage": "CAT 99.09",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anamay Srivastava",
        "persentage": "CAT 99.07",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anika Singh",
        "persentage": "98.9",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Atheenthara Ram S",
        "persentage": "97",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abantika Karmakar",
        "persentage": "95.01",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Prajwal V Sangam",
        "persentage": "91.4",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    }
]

  rankers2020: any[] = [
    { img: 'https://media.iquanta.in/ui_images/Shivam-Kumar.webp', name: 'Shivam Kumar', persentage: 'CAT Percentile: 99.95' },
    { img: 'https://media.iquanta.in/ui_images/Rahul-Agrawal.webp', name: 'Rahul Agrawal', persentage: 'CAT Percentile: 99.92' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sabyasachi-Mishra-small.jpg', name: 'Sabyasachi Mishra', persentage: 'CAT Percentile: 99.90' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Dibyendu-Patra.jpg', name: 'Dibyendu Patra', persentage: 'CAT Percentile: 99.85' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Bitanesh-Bhattacharya.jpg', name: 'Bitanesh Bhattacharya', persentage: 'CAT Percentile: 99.81' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Mayank.jpg', name: 'Mayank', persentage: 'CAT Percentile: 99.76' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Priyanka-Reddy.jpg', name: 'Priyanka Reddy', persentage: 'CAT Percentile: 99.7' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Pranjal-Chaudhary.jpg', name: 'Pranjal Chaudhary', persentage: 'CAT Percentile: 99.7' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Heenal-Raghvani.jpg', name: 'Heenal Raghvani', persentage: 'CAT Percentile: 99.63' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Rishabh-Jain.jpg', name: 'Rishabh Jain', persentage: 'CAT Percentile : 99.62' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Karan-Dutta.jpg', name: 'Karan Dutta', persentage: 'CAT Percentile:  99.56' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Rahul-Arora.jpg', name: 'Rahul Arora', persentage: 'CAT Percentile: 99.56' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Indranil-Mukherjee.jpg', name: 'Indranil Mukherjee', persentage: 'CAT Percentile: 99.54' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Mustafa-Haider.jpg', name: 'Mustafa Haider', persentage: 'CAT Percentile: 99.54' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Prateek-Ayush.jpg', name: 'Prateek Ayush', persentage: 'CAT Percentile : 99.53' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Nikhil-Birajdar.jpg', name: 'Nikhil Birajdar', persentage: 'CAT Percentile: 99.48' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Pragyay-Parashar.jpg', name: 'Pragyay Parashar', persentage: 'CAT Percentile: 99.47' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Reuben Mathew', persentage: 'CAT Percentile: 99.46' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Abhinav-Pali.jpg', name: 'Abhinav Pali', persentage: 'CAT Percentile: 99.45' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Saransh-Mohanty.jpg', name: 'Saransh Mohanty', persentage: 'CAT Percentile: 99.43' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Abhishek-Anshu.jpg', name: 'Abhishek Anshu', persentage: 'CAT Percentile: 99.33' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sapnil-Bhoi.jpg', name: 'Sapnil Bhoi ', persentage: 'CAT Percentile: 99.33 ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Purbita-Seal.jpg', name: 'Purbita Seal', persentage: 'CAT Percentile: 99.33' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sourabh-Singh.jpg', name: 'Sourabh Singh', persentage: 'CAT Percentile: 99.28' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Akshat-Gupta.jpg', name: 'Akshat Gupta', persentage: 'CAT Percentile: 99.23' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Syed-Abdus-Sattar.jpg', name: 'Syed Abdus Sattar', persentage: 'CAT Percentile: 99.2 ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Utkarsh-Joshi.jpg', name: 'Utkarsh Joshi', persentage: 'CAT Percentile: 99.2' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Piyush-Aras.jpg', name: 'Piyush Aras', persentage: 'CAT Percentile: 99.2' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Ankit-Guleria.jpg', name: 'Ankit Guleria', persentage: 'CAT Percentile: 99.2' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Abhinay-Shrivastav.jpg', name: 'Abhinay Shrivastav', persentage: 'CAT Percentile: 99.11' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Ritwik-Tiwari.jpg', name: 'Ritwik Tiwari', persentage: 'CAT Percentile: 99.09' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Ankit-Sagu.jpg', name: 'Ankit Sagu', persentage: 'CAT Percentile: 99.02' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Tarunsree Kata', persentage: 'CAT Percentile : 99.09' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Bharghvi-Prajapati.jpg', name: 'Bharghvi Prajapati', persentage: 'CAT Percentile : 99' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Ananya-Chaudhary.jpg', name: 'Ananya Chaudhary', persentage: 'CAT Percentile: 99' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Harshit-Jain.jpg', name: 'Harshit Jain', persentage: 'CAT Percentile : 99' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Amber Jain', persentage: 'CAT Percentile : 99' },
    { img: 'https://media.iquanta.in/ui_images/Ankit-Raj.webp', name: 'Ankit Raj', persentage: 'CAT Percentile:  99.96' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Syed-Abdus-Khattar.jpg', name: 'Syed Abdus Khattar ', persentage: 'From 74%le to 99.2%le' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Yasser-Khan.jpg', name: 'Yasser Khan', persentage: 'From 21%le to around 90%le' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Anusha-Harikumar.jpg', name: 'Anusha Harikumar', persentage: 'From 68%le to 94.1%le' },
    { img: 'https://media.iquanta.in/ui_images/Ruhi-Singh.webp', name: 'Ruhi Singh', persentage: '99.9 in Quants' },

    { img: 'https://media.iquanta.in/ui_images/cat2020/Govind-Sivan-S.jpg', name: 'Govind Sivan S', persentage: '99.6 in LRDI ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sai-Srikar-Velichety.jpg', name: 'Sai Srikar Velichety', persentage: '99.64 in LRDI ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Harsh-Bhargava.jpg', name: 'Harsh Bhargava', persentage: 'CAT Percentile: 98.84 ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sharique-Ahmad.jpg', name: 'Sharique Ahmad', persentage: 'CAT Percentile : 98.82' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Chirag-Kumar.jpg', name: 'Chirag Kumar', persentage: 'CAT Percentile : 98.81' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Saurav-Surwade.jpg', name: 'Saurav Surwade', persentage: 'CAT Percentile:  98.78' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Amit-Shete.jpg', name: 'Amit Shete', persentage: 'CAT Percentile:  98.69 ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Neharika-Jain.jpg', name: 'Neharika Jain', persentage: 'CAT Percentile:  98.65' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Dibyendu-Bhadra.jpg', name: 'Dibyendu Bhadra', persentage: 'CAT Percentile:  98.6' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Dhruv-Luthra.jpg', name: 'Dhruv Luthra', persentage: 'CAT Percentile:  98.52' },

    { img: 'https://media.iquanta.in/ui_images/cat2020/Anurag-Kumar.jpg', name: 'Anurag Kumar', persentage: 'CAT Percentile:  98.5' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sumeet-Yadav.jpg', name: 'Sumeet Yadav', persentage: 'CAT Percentile:  98.46' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Rupesh-Gupta.jpg', name: 'Rupesh Gupta', persentage: 'CAT Percentile: 98.3' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Pranjal-Gupta.jpg', name: 'Pranjal Gupta', persentage: 'CAT Percentile : 98.14' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Aashita-Jain.jpg', name: 'Aashita Jain', persentage: 'CAT Percentile : 98.06' }
  ]
  rankers2018: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2018/mihir.webp', name: 'Mihir Kapse', persentage: 'CAT Percentile: 99.97' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/ananta.jpg', name: 'Ananta Chhajer', persentage: 'CAT Percentile: 99.91' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/utkarsh.jpg', name: 'Utkarsh Bajpai', persentage: 'CAT Percentile: 99.87' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/aabhas.jpg', name: 'Aabhas Mathur', persentage: 'CAT Percentile: 99.86' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/tushar.jpg', name: 'Tushar Singhal', persentage: 'CAT Percentile: 99.70' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/anurag.jpg', name: 'Anurag Shukla', persentage: 'CAT Percentile: 99.70' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/amar.jpg', name: 'Amar Agrahari', persentage: 'CAT Percentile: 99.67' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/rishabh.jpg', name: 'Rishabh Vijay', persentage: 'CAT Percentile: 99.66' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/kunal.jpg', name: 'Kunal Jain', persentage: 'CAT Percentile: 99.54' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shuvendu.jpg', name: 'Shuvendu Jha', persentage: 'CAT Percentile : 99.54' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/vineet.jpg', name: 'Vineet Bajaj', persentage: 'CAT Percentile:  99.53' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/aditya.jpg', name: 'Aditya Prasad', persentage: 'CAT Percentile: 99.51' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shibashis.jpg', name: 'Shibashis Ganguly', persentage: 'CAT Percentile: 99.51' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/jay.jpg', name: 'Jay Patel', persentage: 'CAT Percentile: 99.46' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/manavdeep.jpg', name: 'Manavdeep Singh', persentage: 'CAT Percentile : 99.40' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/hari.jpg', name: 'Hari Haran', persentage: 'CAT Percentile: 99.39' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/charchil.jpg', name: 'Charchil Jain', persentage: 'CAT Percentile: 99.38' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/jatin.jpg', name: 'Jatin Singla', persentage: 'CAT Percentile: 99.33' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/divey.jpg', name: 'Divey Jot', persentage: 'CAT Percentile: 99.30' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shivam.jpg', name: 'Shivam Khandelwal', persentage: 'CAT Percentile: 99.17' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/bhrigu.jpg', name: 'Bhrigu Chopra', persentage: 'CAT Percentile: 99.16' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/priyanshu.jpg', name: 'Priyanshu Porwal ', persentage: 'CAT Percentile: 99.10' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/sahib.jpg', name: 'Sahib Chawla', persentage: 'CAT Percentile: 99.07' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/sagar.jpg', name: 'Sagar Tavse', persentage: 'CAT Percentile: 99.06' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shailesh Mehta', persentage: 'CAT Percentile: 99.03' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ashish Khetan Potus', persentage: 'CAT Percentile: 99.00' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/ayush1.jpg', name: 'Aayush Agarwal', persentage: 'From 93 to 99.69 Qa' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/sugandha.jpg', name: 'Sugandha Jain ', persentage: 'From 83 to 98 Qa' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/richa.jpg', name: 'Richa Kenkre', persentage: '52 to 92 QA' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/adarsh.jpg', name: 'Adarsh Jaiswal', persentage: '75 to 93 QA' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/Janmejay.jpg', name: 'Janmejay Singh Hada', persentage: '99.86 (QA)' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/Harsh.jpg', name: 'Harsh Wardhan ', persentage: 'CAT Percentile: 98.88' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/ronit.jpg', name: 'Ronit Ray', persentage: 'CAT Percentile : 98.81' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/abhishek.jpg', name: 'Abhishek purab das ', persentage: 'CAT Percentile : 98.86' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/aayush.jpg', name: 'Aayush Agarwal', persentage: 'CAT Percentile: 98.63' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/durga.jpg', name: 'Durga Madhab', persentage: 'CAT Percentile : 98.60' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shivambansal.jpg', name: 'Shivam Bansal', persentage: 'CAT Percentile : 98.66' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shubham.jpg', name: 'Shubham Gupta', persentage: 'CAT Percentile:  98.7' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/rahul.jpg', name: 'Rahul Jeswani ', persentage: 'CAT Percentile : 98.41' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/sriharsha.jpg', name: 'Sri Harsha', persentage: 'CAT Percentile : 97.5' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/akshata.jpg', name: 'Akshata Masoor', persentage: 'CAT Percentile: 98.7' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/younus.jpg', name: 'Younus Waquar', persentage: 'from mere 39% to near 90 %le' },
  ]
  rankers2019: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2019/rishi.webp', name: 'Rishi Mittal', persentage: 'CAT: 100 %ler' },
    { img: 'https://media.iquanta.in/ui_images/kislay.webp', name: 'Kislay Jha', persentage: 'CAT : 99.96 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/deb.jpg', name: 'Deb Singhdeo', persentage: 'CAT : 99.89 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/Romik.jpg', name: 'Romik Banerjee', persentage: 'CAT : 99.87 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/akhil.jpg', name: 'Akhil Bhutada', persentage: 'CAT : 99.73 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/bitanesh.jpg', name: 'Bitanesh Bhattacharya ', persentage: 'CAT : 99.66 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/devesh.jpg', name: 'Devesh Bansal', persentage: 'CAT : 99.65 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/yash.jpg', name: 'Yash Jain', persentage: 'CAT : 99.57 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/karthikgupta.jpg', name: 'Kartik Gupta', persentage: 'CAT : 99.5 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shubham.jpg', name: 'Shubham Sharma', persentage: 'CAT : 99.5 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Raghav Rathore', persentage: 'CAT :  99.49%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/avinash.jpg', name: 'Avinash Singh', persentage: 'CAT : 99.48 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/suman.jpg', name: 'Suman Gande ', persentage: 'CAT:  99.43 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shobhit.jpg', name: 'Shobhit Datta', persentage: 'CAT: 99.40 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/vaibhav.jpg', name: 'Vaibhav Gupta', persentage: 'CAT:  99.38 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/nihal.jpg', name: 'Nihal Singh', persentage: 'CAT : 99.31 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Risab Agnihotri', persentage: 'CAT : 99.25 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/czaee.jpg', name: 'Czaee Shefali Kolekar', persentage: 'CAT : 99.1 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/karal.jpg', name: 'Karal Maheshwari', persentage: 'CAT : 99.03 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/rishabh.jpg', name: 'Rishabh Dwived', persentage: 'CAT :~99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/harsha.jpg', name: 'Harsha Surapaneni', persentage: 'CAT : 99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/arshia.jpg', name: 'Arshia Sethi ', persentage: 'CAT : 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/ankur.jpg', name: 'Ankur Agarwal', persentage: 'CAT :  99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/dhruv.jpg', name: 'Dhruv Dua', persentage: 'CAT :  99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Harsh Patel', persentage: 'CAT : 99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shivansh.jpg', name: 'Shivansh Agarwal', persentage: 'CAT  : ~99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/palak.jpg', name: 'Palak Aneja', persentage: 'CAT : ~ 99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/Prachet.jpg', name: 'Prachet Prakash', persentage: 'CAT :  98.81%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/manan.jpg', name: 'Manan Dhar', persentage: 'CAT :  98.8 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/ayush.jpg', name: 'Ayush Jhingala', persentage: 'CAT : 98.6 %ler' },
    // {img: 'https://media.iquanta.in/ui_images/cat2019/abhishek.jpg', name: 'Abhishek Smarty', persentage: 'CAT : 99.79 %ler'},
    // {img: 'https://media.iquanta.in/ui_images/cat2019/ankit.jpg', name: 'Ankit Desai', persentage: 'CAT : 99.91 %ler'},
    { img: 'https://media.iquanta.in/ui_images/cat2019/riyank.jpg', name: 'Riyank Roy', persentage: 'CAT : 98.6 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/biswarup.jpg', name: 'Biswarup Ghosh', persentage: 'CAT : 98.03 %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shivam.jpg', name: 'Shivam Bansal', persentage: 'CAT  : 98.44 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Abhinav Pruthi ', persentage: 'CAT  : 98.81 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Faisal khan', persentage: 'CAT  : 98.54 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/yugank.jpg', name: 'Yugank Trivedi ', persentage: 'CAT  : 98.5 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/sourav.jpg', name: 'Sourav Naik', persentage: 'CAT : 98.3 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shreya.jpg', name: 'Shreya Gupta', persentage: 'CAT : 98.11 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/dattatreya.jpg', name: 'Dattatreya Singh', persentage: 'CAT : 98.2 %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/priyesh.jpg', name: 'Priyesh Patel', persentage: 'CAT 98+ %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/nilesh.jpg', name: 'Nilesh Majumdar', persentage: 'CAT 98+ %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/mohitshah.png', name: 'Mohit Shah', persentage: 'CAT 98+ %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/sachin.jpg', name: 'Sachin Raj', persentage: 'CAT 98+ %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/akash.jpg', name: 'Akash Pandey', persentage: '99.76 in VARC' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Devendra Varma', persentage: '99.5 + in both LRDI & VARC' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/anubhav.jpg', name: 'Anubhav Satapathy', persentage: 'from a mere 60%le to 96%le around' },
  ]
  rankers2017: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2017/shikhar.webp', name: 'Shikhar Sachdeva', persentage: 'CAT 99.98% ler ( QA 100% ler)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/gaurav.webp', name: 'Gaurav Saha ', persentage: 'CAT 99.90 %ler (CAT 99.92 %le in Quant)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/aabhas.webp', name: 'Aabhas Mathur', persentage: '99.85 %ler(CAT 99.96 in Quant)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/suhrit.jpg', name: 'Suhrit Sur ', persentage: 'CAT 99.85 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sameer.jpg', name: 'Sameer Sodani ', persentage: 'CAT 99.80 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/siddharth.jpg', name: 'Siddharth Sridhar', persentage: 'CAT 99.78 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sahil.jpg', name: 'Sahil Aggarwal ', persentage: 'CAT 99.77 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/bharat.jpg', name: 'Bharat Santani ', persentage: 'CAT 99.67 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/siddhartha.jpg', name: 'Siddhartha Choudhury', persentage: 'CAT 99.63 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sourav.jpg', name: 'Sourav Bikash ', persentage: 'CAT 99.58 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/harshit.jpg', name: 'Harshit Sharma', persentage: 'CAT 99.54 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aditya Kumar Singh ', persentage: 'CAT 99.4 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/bijay.jpg', name: 'Bijay Sharma', persentage: 'CAT 99.36 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/digvijay.jpg', name: 'Digvijay Sinha ', persentage: 'CAT 99.29 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/soham.jpg', name: 'Soham De', persentage: 'CAT 99.28 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/ben.jpg', name: 'Ben Harison ', persentage: 'CAT 99.25 (awesome raise from 90.25 last year)' },
    { img: 'https://media.iquanta.in/ui_images/ananta.webp', name: 'Ananta Chhajer ', persentage: 'CAT 99.21 (you deserve a 100 next year)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/bhavya.jpg', name: 'Bhavya Shah ', persentage: 'CAT 99.12 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/prateek.jpg', name: 'Prateek Gambhir ', persentage: 'CAT 99.10 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aman Jain ', persentage: 'CAT 99.07 (Sabse jada doubts puchne wala from course  :p )' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/himanshu.jpg', name: 'Himanshu Singla', persentage: 'CAT 99.06 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sounak.jpg', name: 'Sounak Kundu ', persentage: 'CAT 99.04 (you deserve more, youll get more)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/abhishek.jpg', name: 'Abhishek Paul  ', persentage: 'CAT 99.03 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/navneet.jpg', name: 'Navneet Gulati ', persentage: 'CAT 99.02 (very consistent boy wid prep)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/adarsh.jpg', name: 'Adarsh Srivastava ', persentage: 'CAT 99 (hardworking boy)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/naman.jpg', name: 'Naman Chaudhary', persentage: 'CAT 82 to 98' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/aditya.jpg', name: 'Aditya Anand', persentage: 'CAT 93 to 98 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pranav Khera', persentage: 'CAT  87 to 97 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/upasana.jpg', name: 'Upasana Ghosh', persentage: 'CAT  60%le to 93' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Himanshu Sharma', persentage: 'CAT 72 to 97%le ' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/subhadev.jpg', name: 'Subhadev Pal ', persentage: 'CAT 98.6 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sambhid.jpg', name: 'Sambhid Gourav  ', persentage: 'CAT 95 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/akash.jpg', name: 'Akash Bansal ', persentage: 'CAT 97.7 %le' }
  ]

  rankers2016: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2016/viraat.jpg', name: 'Viraat Gupta', persentage: 'CAT 99.82 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/dhruv.webp', name: 'Dhruv Gupta', persentage: 'CAT 99.98 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Debasmita Kumar', persentage: 'CAT 99.35 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/aditya.jpg', name: 'Aditya Chandrayan', persentage: 'CAT 99.72 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/gaurav.jpg', name: 'Gaurav Gupta', persentage: 'CAT 99.44 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Anmol Narang', persentage: 'CAT 99.46  %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/prince.jpg', name: 'Prince Jain', persentage: 'CAT 99.48 %ler' },
    { img: 'https://media.iquanta.in/ui_images/pratik.webp', name: 'Pratik Sahoo ', persentage: 'CAT 99.94 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pawan Rathi', persentage: 'CAT 99.73 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aritra Chakrabarti ', persentage: 'CAT 99.56 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Piyush Joshi ', persentage: 'CAT 99.41 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/anirban.jpg', name: 'Anirban Sinha', persentage: 'CAT 99.17 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/anubhav.jpg', name: 'Anubhav Sinha ', persentage: 'CAT 99.67 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/ankit.jpg', name: 'Ankit Kumar ', persentage: 'CAT  99.35 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/akshat.jpg', name: 'Akshat Jain  ', persentage: 'CAT  99.78 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/soumya.jpg', name: 'Soumya Ranjan Tripathy', persentage: 'CAT 99.41 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Akshat Gupta ', persentage: 'CAT 99.61 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jake Anderson', persentage: 'CAT 99.92 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/nayan.jpg', name: 'Nayan Chatterjee', persentage: 'CAT 99.84 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/sandeep.jpg', name: 'Sandeep Patra ', persentage: 'CAT 99.6 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/abhishek.jpg', name: 'Abhishek Maurya  ', persentage: 'CAT 99.39 %ler' }
  ]

  rankers2015: any[] = [
    // { img: 'https://media.iquanta.in/ui_images/cat2015/prateek.webp', name: 'Prateek Bajpai ', persentage: 'The CAT 100 %ler (250 marks) ' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/sabyasachi.webp', name: 'Sabyasachi Mishra', persentage: 'CAT 100 %ler' },
    { img: 'https://media.iquanta.in/ui_images/rahul.webp', name: 'Rahul Das', persentage: 'CAT 99.94 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Dhruv+Bindal.jpg', name: 'Dhruv Bindal', persentage: 'CAT 99.94 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Mohit+Jain.jpg', name: 'Mohit Jain', persentage: 'CAT 99.93 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/siddharth.jpg', name: 'Siddharth Sridhar', persentage: 'CAT 99.92 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Atul+Gandhi.jpg', name: 'Atul Gandhi', persentage: 'CAT 99.92 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Sumit Ranjan', persentage: 'CAT  99.85 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/gursimran.jpg', name: 'Gursimran Ahuja', persentage: 'CAT 99.83 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Nishchay+Nath.jpg', name: 'Nishchay Nath', persentage: 'CAT 99.78 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Lakshay+Pandhi.jpg', name: 'Lakshay Pandhi', persentage: 'CAT 99.7 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Debarshee+Mitra.jpg', name: 'Debarshee Mitra', persentage: 'CAT 99.68 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Rhitwiz Tripathi', persentage: 'CAT 99.68 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Rahul+Dubey.jpeg', name: 'Rahul Dubey', persentage: 'CAT 99.62 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/malay.jpg', name: 'Malay Krishna', persentage: 'CAT 99.62 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Rajan+Pandey.jpeg', name: 'Rajan Pandey', persentage: 'CAT 99.92 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/akshat.jpg', name: 'Akshat Gupta', persentage: 'CAT 99.6 %ler' }
  ]


  rankers2021: any[] = [
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Gauravi+Kabadi.png', name: 'Gauravi Kabadi', persentage: 'CAT 99.95 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Rishabh Bansal', persentage: 'CAT 99.95 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Uttkarsh Arora', persentage: 'CAT 99.83 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Atharva Kanitkar', persentage: 'CAT 99.83 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Biman+Barai.png', name: 'Biman Barai ', persentage: 'CAT 99.83 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Devansh+Tyagi.png', name: 'Devansh Tyagi ', persentage: 'CAT 99.82 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Sukhveen+Kaur.png', name: 'Sukhveen Kaur', persentage: 'CAT 99.73 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Rajat+Tiwary.png', name: 'Rajat Tiwary', persentage: 'CAT  99.66 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pallavi M ', persentage: 'CAT 99.64 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Aditya+Tripathi.png', name: 'Aditya Tripathi', persentage: 'CAT 99.59 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Gautam+Rai.png', name: 'Gautam Rai ', persentage: 'CAT 99.56 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Rounak+Das.png', name: 'Rounak Das ', persentage: 'CAT 99.56 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Siddhant+Bhagat.png', name: 'Siddhant Bhagat', persentage: 'CAT 99.53 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Satya Sripada', persentage: 'CAT 99.51 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Srinath Rao', persentage: 'CAT 99.46 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Shivam+Dubey.png', name: 'Shivam Dubey ', persentage: 'CAT 99.39 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Dhruv+Jhalani.png', name: 'Dhruv Jhalani', persentage: 'CAT 99.31 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Vidisha Chintalapudi', persentage: 'CAT 99.21 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Ravi+Ranjan.png', name: 'Ravi Ranjan', persentage: 'CAT 99.2 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubham Jaju', persentage: 'CAT 99.19 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Sudhanshu kumar ', persentage: 'CAT 99.18 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Naveen Krishna ', persentage: 'CAT 99.1 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Tanush Meshram ', persentage: 'CAT 99.09 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Samarth+Vats.jpg', name: 'Samarth Vats ', persentage: 'CAT 99.03 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pratyush Pratap Saikia ', persentage: 'CAT  99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Tushaar ERr ', persentage: 'CAT 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Sehaj+Miglani.png', name: 'Sehaj Miglani ', persentage: 'CAT 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Rohith Siva Ganesh ', persentage: 'CAT 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jefrin Sabu', persentage: 'CAT 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Akshay Bhargava', persentage: '98.45%le NMAT 251' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Asmeet Kaur', persentage: 'CAT 98+ %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shashwat', persentage: 'CAT 97 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aayushi Dubey ', persentage: 'CAT 97 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Garima Bedi ', persentage: 'CAT 96.2 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Shantanu+Bhowmick.png', name: 'Shantanu Bhowmick ', persentage: 'CAT 95.5 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubhashish Gargari', persentage: 'Best 95 %ler' }

  ]

  rankers2022: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Mridul Agarwal', persentage: 'CAT 99.99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Adarsh+Khandelwal.png', name: 'Adarsh Khandelwal ', persentage: 'CAT 99.93 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Geetsaisumant+Jupudi.jpeg', name: 'Geetsaisumant Jupudi ', persentage: 'CAT 99.9 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Pranav+Bahedia.jpg', name: 'Pranav Bahedia', persentage: 'CAT 99.82 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Atish+Naskar.jpeg', name: 'Atish Naskar', persentage: 'CAT 99.81 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Siddharth Pandey', persentage: 'CAT 99.78 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubham Jaju', persentage: 'CAT 99.74 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Pavan+Ch.jpg', name: 'Pavan Ch', persentage: 'CAT  99.73 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Gaurav+Harlalka.jpg', name: 'Gaurav Harlalka', persentage: 'CAT 99.70 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Rishab+Rahiman.jpg', name: 'Rishab Rahiman', persentage: 'CAT 99.63 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Kapil+Yadav.jpg', name: 'Kapil Yadav', persentage: 'CAT 99.59 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Govinda+Aditya.jpg', name: 'Govinda Aditya', persentage: 'CAT 99.53 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Manan ', persentage: 'CAT 99.50 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Kshitij+Singhal.jpg', name: 'Kshitij Singhall', persentage: 'CAT 99.44 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Harkiran+Chawla.png', name: 'Harkiran Chawla', persentage: 'CAT 99.41 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Chinmay+Paltewar.jpg', name: 'Chinmay Paltewar', persentage: 'CAT 99.35 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Sanjit+Sarkar.jpg', name: 'Sanjit Sarkar', persentage: 'CAT 99.28 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Vaibhav+Singh.png', name: 'Vaibhav Singh', persentage: 'CAT 99.25 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Arpit Gaur ', persentage: 'CAT 99.2 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubham Gupta ', persentage: 'CAT 99.2 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Samyak Jain ', persentage: 'CAT 99.19 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'aman sharma', persentage: 'CAT 99.13 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Nimish More ', persentage: 'CAT 99.12 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Sai+Santosh.jpg', name: 'Sai Santosh', persentage: 'CAT 99.08 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Tanya+Jain.png', name: 'Tanya Jain', persentage: 'CAT  99.05 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jasmeet Kaur ', persentage: 'CAT 99.02 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Imran+Anas.jpg', name: 'Imran Anas', persentage: 'CAT 98.8 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Srajal Dwivedi', persentage: 'CAT 98.60 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Ayan+Ganguly.jpg', name: 'Ayan Ganguly ', persentage: 'CAT 98.52 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Madhushree+Gupta.jpg', name: 'Madhushree Gupta', persentage: 'CAT 98.5 %ler' }
  ]
}